import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=f8e774d2&"
import script from "./TestPage.vue?vue&type=script&lang=js&"
export * from "./TestPage.vue?vue&type=script&lang=js&"
import style0 from "./TestPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports